export default {
  liveClassSchedule: {
    id: "",
    courseOutlineId: "",
    vdoSetId: "",
    vdoSetUnitId: "",
    no: 0,
    nameLocal: "",
    nameEng: "",
    vdoLength: 0,
    vdoStreamPath: "",
    teacherId: "",
    isEnabled: true,
    remark: "",
    externalLink: "",
    externalPassword: "",
  },
  liveClassSchedules: [],
  processing: false,
  error: null,
  success: null,
}



